/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/observe-assess/observe-assess',['require','underscore','backbone','core/base-screen','screens/observe-assess/question','screens/observe-assess/scene','modules/components/feedback'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var Backbone = require('backbone');
  // var templates = require('core/templates');
  var BaseScreen = require('core/base-screen');
  var Question = require('screens/observe-assess/question');
  var Scene = require('screens/observe-assess/scene');
  var Feedback = require('modules/components/feedback');

  /*****************************************************************************************************************///}

  var ObserveAssess = BaseScreen.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    options: {
      shuffleQuestions: false,
      shuffleResponses: false,
      maxAttempts: 2,
    },

    regions: {
      scene: '.scene-holder',
      question: '.question-holder',
      feedback: '.feedback-holder'
    },

    scenes: [],
    currentScene: null,
    feedback: null,
    disabled: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('ObserveAssess::initialize');
    },

    onShow: function()
    {
      this.playMedia();

      this.scenes = new Backbone.Collection(this.model.get('scenes'));

      this.setupScene();
    },

    setupScene: function()
    {
      //console.log('ObserveAssess::setupQuestion');

      this.question.$el.hide();

      if (this.scenes.length)
      {
        this.currentScene = this.scenes.shift();

        var sceneView = new Scene({ model: this.currentScene });

        sceneView.on('action:pressed', this.actionPressed, this);
        this.scene.show(sceneView);

        var media = this.currentScene.get('media');
        if (media && !media.played)
        {
          this.playMedia({ media: media });
          media.played = true;
        }
      }
      else
      {
        this.finish();
      }
    },

    actionPressed: function(action, correct)
    {
      this.scene.currentView.disable();
      var feedback = this.model.get('feedback');

      if (!action && correct)
        this.showFeedback(feedback['correct'], this.setupScene, { layout: 'correct' });
      else if (!action && !correct)
        this.showFeedback(feedback['incorrect'], this.setupScene, { layout: 'incorrect' });
      else if (action && !correct)
        this.showFeedback(feedback['incorrect'], this.setupQuestion, { layout: 'incorrect' });
      else
        this.setupQuestion();
    },

    setupQuestion: function()
    {
      //console.log('ObserveAssess::setupQuestion');

      var question = new Backbone.Model(this.currentScene.get('question'));

      var options = new Backbone.Collection(question.get('options'));

      var questionView = new Question({ model: question, collection: options, options: this.options });

      questionView.on('option:pressed', this.itemPressed, this);
      this.question.show(questionView);
    },

    itemPressed: function(option)
    {
      this.question.currentView.disable();
      //console.log(option);

      this.checkFeedback(option);

      return false;
    },

    checkFeedback: function(option)
    {
      var feedback = option.get('feedback');
      if (feedback)
      {
        var layout = (option.get('correct')) ? 'correct' : 'incorrect';
        this.showFeedback(feedback, this.setupScene, { layout: layout });
      }
      else
      {
        this.setupScene();
      }
    },

    showFinalFeedback: function()
    {
      var feedback = this.model.get('feedback');

      if (!feedback)
        return;

      if (feedback['final'])
        this.showFeedback(feedback['final'], null, { layout: 'correct final' });
    },

    showFeedback: function(feedback, onDestroy, params)
    {
      onDestroy = onDestroy || _.noop;
      params = params || { };

      if (!feedback)
      {
        //console.log('Feedback not found.');
        onDestroy();
        return;
      }

      var model = new Backbone.Model(feedback);

      _.each(params, function(value, key)
      {
        model.set(key, value);
      });

      //console.log(params);
      //console.log(model);

      var feedbackView = new Feedback({ model: model });
      feedbackView.on('destroy', onDestroy, this);
      this.feedback.show(feedbackView);
    },

    finish: function()
    {
      BaseScreen.prototype.finish.apply(this, arguments);

      //console.log('ObserveAssess::finish');

      this.showFinalFeedback();
    }

  /*****************************************************************************************************************///}

  });

  return ObserveAssess;

});

